/* eslint-disable react/prop-types */
import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';
import { CALENDAR_CONTEXT } from '@confluence/team-calendar';

const SpaceTeamCalendarsRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-SpaceTeamCalendarsRouteComponent" */ './SpaceTeamCalendarsRouteComponent.tsx'
		),
});

export const SpaceTeamCalendarsRoute: {
	({ params: { subCalendarId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey, subCalendarId } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					isSingleCalendar: boolean;
				};
			};
			pageState: {
				spaceKey: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
		};
	};
} = ({ params: { subCalendarId } }: RouteMatch): React.JSX.Element => {
	const calendarContext = subCalendarId
		? CALENDAR_CONTEXT.SPACE_SUBCALENDAR
		: CALENDAR_CONTEXT.SPACE_CALENDARS;

	return (
		<SpaceTeamCalendarsRouteComponent
			subCalendarId={subCalendarId}
			calendarContext={calendarContext}
		/>
	);
};

SpaceTeamCalendarsRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey, subCalendarId },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
			attributes: {
				isSingleCalendar: boolean;
			};
		};
		pageState: {
			spaceKey: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
	};
} => {
	return {
		Screen: {
			screenEvent: {
				name: 'spaceTeamCalendarsScreen',
				id: spaceKey,
				attributes: {
					isSingleCalendar: !!subCalendarId,
				},
			},
			pageState: { spaceKey },
		},
		MainLayout: {
			navView: CONTAINER_HOME_ID,
			spaceKey,
		},
	};
};
